import aboutusBG from "../images/section-1-bg-about-us.png";
import "../CSS/section-1-aboutus.css";
function SectionAboutus1() {
    return (
        <div className="section-about-1">
            <img src={aboutusBG} alt="bg-about" />
        </div>
    )
}
export default SectionAboutus1;